import {Component, Input, OnInit} from '@angular/core';
import moment from 'moment';
import { EventsRefreshService } from '../services/events-refresh.service';
import {AdminDashboardService} from '../services/admin-dashboard.service';
import { v4 as uuid } from 'uuid';

@Component({
    selector: 'app-events-pane-container',
    templateUrl: './events-pane-container.component.html',
    styleUrls: ['./events-pane-container.component.scss'],
    standalone: false
})
export class EventsPaneContainer implements OnInit {
  data: Array<Object> = [
    { period: "Past Week" },
    { period: "Past Month" },
    { period: "Past Quarter" },
    { period: "Past Year" },
  ];

  public charts;
  public tables;
  public now: string;
  public lastWeek: string;
  public lastYear: string;
  public lastMonth: string;
  public lastQuarter: string;
  public selectedPeriod;
  public selectedPeriodName;
  public statusPeriodMenu: boolean;
  public statusBetweenPeriods: boolean;
  public date1;
  public date2;
  public refreshCount = 0;
  errorMessage: boolean;
  private _uid;
  @Input() public set uid(id){
    this._uid = id;
    this.retrieveSettings();
  };
  public get uid() : string{
    return this._uid;
  };

  constructor(public refresher: EventsRefreshService, public admin: AdminDashboardService) {
    this.now = moment().format('YYYY-MM-DD');
    this.lastWeek = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
    this.lastMonth = moment().subtract(1, 'months').format('YYYY-MM-DD');
    this.lastQuarter = moment().subtract(3, 'months').format('YYYY-MM-DD');
    this.lastYear = moment().subtract(1, 'years').format('YYYY-MM-DD');
  }

  ngOnInit(): void {
    this.selectedPeriodName = "Past Week";
    this.selectedPeriod = this.lastWeek;
    this.refresher.changeMessage(JSON.stringify({startDate: this.selectedPeriod, endDate: this.now}));
    this.charts = this.charts || [];
    this.tables = this.tables || [];
  }

  openPeriodMenu() {
    this.statusPeriodMenu = !this.statusPeriodMenu;
  }

  checkPeriod($event, section, periodName) {
    this.selectedPeriodName = periodName;
    switch (section) {
      case 'pastWeek':
        this.selectedPeriod = this.lastWeek;
        this.statusPeriodMenu = false
        this.statusBetweenPeriods = false;
        break;
      case 'pastMonth':
        this.selectedPeriod = this.lastMonth;
        this.statusPeriodMenu = false;
        this.statusBetweenPeriods = false;
        break;
      case 'pastQuarter':
        this.selectedPeriod = this.lastQuarter;
        this.statusPeriodMenu = false;
        this.statusBetweenPeriods = false;
        break;
      case 'pastYear':
        this.selectedPeriod = this.lastYear;
        this.statusPeriodMenu = false;
        this.statusBetweenPeriods = false;
        break;
      case 'custom':
        this.selectedPeriod = 'custom';
        this.statusBetweenPeriods = true;
        break;
      case 'clickPeriod':
        this.statusBetweenPeriods = false;
        this.statusPeriodMenu = false
        this.calculatePeriod()
        break;
    }
    this.refreshCount++;
    let update = JSON.stringify({ startDate: this.selectedPeriod, endDate: this.now });
    if (this.selectedPeriod === 'custom') {
      update = JSON.stringify({ startDate: moment(this.date1, 'YYYY-MM-DD'), endDate: moment(this.date2, 'YYYY-MM-DD') });
    }
    this.refresher.changeMessage(update);
  }
  calculatePeriod() {
    const date1 = moment(this.date1, 'YYYY-MM-DD');
    const date2 = moment(this.date2, 'YYYY-MM-DD');

    if (this.date1 === '' || this.date2 === '') {
      this.statusPeriodMenu = true;
      this.statusBetweenPeriods = true;
      this.errorMessage = true;
    } else if ((this.date1 === '' && this.date2 !== '') || (this.date2 === '' && this.date1 !== '')) {
      this.errorMessage = true;
    } else {
      this.statusBetweenPeriods = false;
      this.date1 = '';
      this.date2 = '';
    }
  }
  public addChart() {
    this.charts.push({id:uuid()})
    this.saveSettings();
  }
  public addTable(){
    this.tables.push({id:uuid()})
    this.saveSettings();
  }
  public async deleteWidget(uid){
    let index = this.tables.findIndex(table => table.id === uid);
    let saveResult = false;
    if(index >= 0) {
      this.tables.splice(index, 1);
      saveResult = await this.saveSettings();
    }

    if(!saveResult) {
      index = this.charts.findIndex(chart => chart.id === uid);
      if (index >= 0) {
        this.charts.splice(index, 1);
        saveResult = await this.saveSettings();
      }
    }

    if(saveResult){
      return await this.retrieveSettings();
    }
  }
  public async retrieveSettings() {
    if(this._uid) {
      let settings = await this.admin.retrieveDashboardInfo("dashboards", this._uid);
      if (settings) {
        this.charts = settings['charts'];
        this.tables = settings['tables'];
      }
    }
  }
  public async saveSettings(){
    let settings = {};
    if(this._uid) {
      settings['id'] = this._uid;
      settings['charts'] = this.charts;
      settings['tables'] = this.tables;
      return await this.admin.saveDashboardInfo("dashboards", settings);
    }

  }
}
